function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_0:889)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.3501 37.99L46.2521 38.0277L31.3491 43.7165V26.4343L35.8501 24.7172V30.8884C35.8501 31.1867 35.9951 31.4686 36.2381 31.6416C36.4741 31.8106 36.7781 31.8523 37.0681 31.7455L41.2671 30.1423C41.6161 30.008 41.8491 29.6629 41.8491 29.2853V22.427L46.3501 20.7088V37.99ZM36.7511 22.4168L32.7751 20.7475L34.6521 19.9353L38.5731 21.7226L36.7511 22.4168ZM37.6501 24.0301L40.0501 23.114V28.6491L37.6501 29.5652V24.0301ZM30.4711 24.8139L18.0361 19.3887L30.4711 13.9645L30.5281 13.9859L44.6861 19.3887L40.9681 20.8086L35.0191 18.095C34.7671 17.98 34.4731 17.9922 34.2311 18.1255L30.0991 19.9139C29.7651 20.0564 29.5501 20.3902 29.5501 20.7628C29.5501 21.1353 29.7691 21.4682 30.1081 21.6086L34.2801 23.3624L30.4711 24.8139ZM29.5501 43.6493L16.6501 38.0216V20.7791L29.5501 26.4058V43.6493ZM48.1501 38.6262V19.4121C48.1461 19.3989 48.1411 19.3836 48.1381 19.3653C48.1241 19.292 48.1211 19.2401 48.1171 19.1943C48.1121 19.1403 48.1091 19.1098 48.0921 19.066C48.0841 19.0457 48.0701 19.0243 48.0501 18.9968C48.0361 18.9754 48.0201 18.954 48.0061 18.9306L47.9821 18.8899C47.9721 18.8716 47.9621 18.8543 47.9491 18.837C47.8441 18.6975 47.7201 18.5988 47.5791 18.5439L47.5381 18.5225L31.2851 12.1375C31.0571 12.0469 30.0941 12.0448 29.8901 12.1344L15.4171 18.5357C15.4051 18.5479 15.3861 18.5642 15.3601 18.5754C15.2481 18.6294 15.1431 18.7199 15.0521 18.8421C15.0261 18.8767 15.0031 18.9062 14.9811 18.9439C14.9701 18.9632 14.9551 18.9836 14.9401 19.0029C14.8731 19.1424 14.8501 19.2635 14.8501 19.3866V38.6262C14.8501 38.9936 15.0641 39.3254 15.3961 39.47L30.0961 45.8825C30.3061 45.9731 30.5411 45.9802 30.7681 45.8967L30.8021 45.8825L47.5671 39.4842C47.9151 39.3509 48.1501 39.0058 48.1501 38.6262Z",
  fill: "#333333"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.7554 55.22C27.6704 57.4623 34.2874 57.5804 40.2324 55.5539C46.2244 53.51 51.3774 49.3948 54.7434 43.9666C57.9734 38.7582 59.4374 32.5656 58.8874 26.4727L56.6164 26.7281C57.1094 32.2999 55.7674 37.9622 52.8134 42.7268C49.7264 47.7031 45.0004 51.4753 39.5084 53.3482C36.9254 54.2286 34.2314 54.6754 31.4994 54.6754C23.7074 54.6744 16.2084 50.9959 11.4404 44.8348L10.8024 44.0103H14.5834V41.6866H6.80444V50.0167H9.08744V45.5839L9.97444 46.6822C13.0714 50.5216 17.1464 53.4734 21.7554 55.22Z",
  fill: "#333333"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.4917 4.68797C28.9177 2.83954 34.6247 2.89858 39.9947 4.85795C44.1777 6.38576 47.9067 9.02201 50.7807 12.4817L51.4767 13.3194L47.7697 13.3184L47.7677 15.6421L55.6457 15.6452V7.7334H53.3617V11.985L52.4807 10.9295C49.3507 7.18172 45.2997 4.32561 40.7647 2.67058C37.7477 1.56926 34.6327 1.01758 31.5127 1.01758C28.5757 1.01758 25.6357 1.50615 22.7667 2.48329C16.6917 4.55565 11.4927 8.74413 8.12773 14.2792C4.89273 19.5975 3.49373 25.8971 4.16373 32.0724L6.42973 31.7752C5.82573 26.1271 7.11073 20.3681 10.0697 15.5027C13.1547 10.4277 17.9227 6.58729 23.4917 4.68797Z",
  fill: "#333333"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_0:889",
  x: 0,
  y: 0,
  width: 64,
  height: 65,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_0:889"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_0:889",
  result: "shape"
})));

var SvgExchangeItemIcon = function SvgExchangeItemIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 65,
    viewBox: "0 0 63 65",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExchangeItemIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Exchange_item_icon.426c1644.svg";
export { ForwardRef as ReactComponent };